import React from 'react';
import { connect } from 'react-redux';
import StyledReactTable from 'components/molecules/StyledReactTable';
import { addExportConfig, updateExportConfig, destroyExportConfig } from 'services/exports/duck';
import { formatColumnsForExport } from 'helpers/tables';


class ExportableTable extends React.PureComponent {
    constructor(props) {
        super(props);

        if (!props.exportName) {
            console.warn('ExportableTable: Missing exportName from table'); // eslint-disable-line no-console
        }
    }

    componentDidMount() {
        if (this.props.exportName) {
            this.props.addExportConfig({
                exportName: this.props.exportName,
                type: 'table',
                title: this.props.title,
                keyField: this.props.keyField,
                minRows: this.props.minRows,
                exportRows: this.props.exportRows,
                data: this.props.data,
                columns: formatColumnsForExport(this.props.columns),
                defaultSorted: this.props.defaultSorted,
                meta: this.props.meta,
                headerDepth: this.props.headerDepth
            });
        }
    }

    componentDidUpdate() {
        if (this.props.exportName) {
            this.props.updateExportConfig({
                exportName: this.props.exportName,
                type: 'table',
                title: this.props.title,
                keyField: this.props.keyField,
                minRows: this.props.minRows,
                exportRows: this.props.exportRows,
                data: this.props.data,
                columns: formatColumnsForExport(this.props.columns),
                defaultSorted: this.props.defaultSorted,
                meta: this.props.meta,
                headerDepth: this.props.headerDepth
            });
        }
    }

    componentWillUnmount() {
        if (this.props.exportName) {
            this.props.destroyExportConfig({
                exportName: this.props.exportName
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                <StyledReactTable {...this.props}/>
            </React.Fragment>);
    }
}


export default connect(null, {
    addExportConfig,
    updateExportConfig,
    destroyExportConfig
})(ExportableTable);



// WEBPACK FOOTER //
// ./src/containers/tables/ExportableTable.js